<template>
<div class="card-body">

  <div class="search-wrap">
    <el-button size="mini" type="primary" @click="editUser()" style="margin-right: 5px;" icon="el-icon-plus">添加</el-button>
    <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
    <el-button size="mini" type="primary text2" @click="search">搜索</el-button>
  </div>

  <div class="table-wrap">
    <el-table v-loading="loading" class="chat-table" :data="tableData">
      <el-table-column prop="id" label="ID" align="left" width="50"></el-table-column>
      <el-table-column prop="name" label="样式名称" align="center"></el-table-column>
<!--      <el-table-column prop="images" label="样式图片" align="center">-->
<!--        <template slot-scope="scope">-->
<!--          <el-image-->
<!--            style="width: 100px; height: 50px"-->
<!--            :src="hostUrl(scope.row.images)"-->
<!--            fit="cover"></el-image>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="nav_bar_color" label="头部导航条" align="center">-->
<!--        <template slot-scope="scope">-->
<!--          <el-color-picker v-model="scope.row.nav_bar_color" @change="setFormItem(scope.row)"></el-color-picker>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="bottom_bar_color" label="底部导航栏" align="center">-->
<!--        <template slot-scope="scope">-->
<!--          <el-color-picker v-model="scope.row.bottom_bar_color" @change="setFormItem(scope.row)"></el-color-picker>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="theme_color" label="主题色" align="center">-->
<!--        <template slot-scope="scope">-->
<!--          <el-color-picker v-model="scope.row.theme_color" @change="setFormItem(scope.row)"></el-color-picker>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" @change="setFormItem(scope.row)" />
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="180">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" icon="el-icon-edit" @click="editUser(scope.row)">修改</el-button>
<!--          <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteUser(scope.row)">删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>
  </div>

  <div class="pagination-wrap">
    <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="page" @current-change="pageChange"></el-pagination>
  </div>

  <!-- 修改窗口 -->
  <el-dialog title="主题编辑" :visible.sync="dialogVisible" width="1000px">
    <el-form :model="form" :rules="rules" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
      <el-form-item label="主题名称" prop="name">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="导航条颜色" prop="name">
        <el-color-picker v-model="form.nav_bar_color"></el-color-picker>
      </el-form-item>
      <el-form-item label="底部颜色" prop="name">
        <el-color-picker v-model="form.bottom_bar_color"></el-color-picker>
      </el-form-item>
      <el-form-item label="主题颜色" prop="name">
        <el-color-picker v-model="form.theme_color"></el-color-picker>
      </el-form-item>
      <el-form-item label="主题内容">
        <div class="theme-content">
          <draggable animation="300" v-model="theme_list" @start="draggableStart" @end="draggableEnd">
              <div class="theme-content-item" v-for="(element,index) in theme_list" :key="element.id">
                <el-row>
                  <el-col :span="6">
                    {{element.name}}
                  </el-col>
                  <el-col :span="5">
                    {{getTypeName(element.type)}}
                  </el-col>
                  <el-col :span="9">
                    --
                  </el-col>
                  <el-col :span="4">
                    <el-button v-if="isEditorType(element.type)" type="success" icon="el-icon-edit" @click="editorTheme(element)" circle></el-button>
                    <el-button v-if="isDelType(element.type)" type="danger" icon="el-icon-delete" @click="delTheme(element)" circle></el-button>
                  </el-col>
                </el-row>
              </div>
            <div slot="footer" class="theme-content-footer">
              <el-button size="mini" type="primary" @click="editorTheme()" round>添加</el-button>
            </div>
          </draggable>
        </div>
      </el-form-item>
      <el-form-item label="状态" prop="name">
        <el-switch v-model="form.status" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitForm('form')" :loading="formLoading">确 定</el-button>
    </div>
  </el-dialog>

  <el-dialog title="样式编辑" :visible.sync="themeDialogVisible" width="800px">
    <el-form :model="themeForm" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
      <el-form-item label="名称" prop="name">
        <el-input v-model="themeForm.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="类型">
        <el-select
          v-model="themeForm.type"
          placeholder="选择类型">
          <el-option
            v-for="item in type_list"
            :key="item.value"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="内容">
        <template v-if="themeForm.type==='card'">
          <UploadFileSysc v-model="themeForm.value" :host-url="host_url" :upload-url="host_url+'/admin/common/uploadFile?name=card_style'" />
        </template>
        <template v-if="themeForm.type==='image'">
          <UploadFileSysc v-model="themeForm.value" :host-url="host_url" :upload-url="host_url+'/admin/common/uploadFile?name=card_style'" />
        </template>
        <template v-if="themeForm.type==='video'">
          <UploadFileSysc v-model="themeForm.value" :host-url="host_url" :upload-url="host_url+'/admin/common/uploadFile?name=card_style'" />
        </template>
        <template v-if="themeForm.type==='images_col'">
<!--          <UploadFilesSysc v-model="themeForm.value" :limit="6" :host-url="host_url" :upload-url="host_url+'/admin/common/uploadFile?name=card_style'" />-->
          <UploadImage v-model="themeForm.value" />
        </template>
        <template v-if="themeForm.type==='images_row'">
          <!--          <UploadFilesSysc v-model="themeForm.value" :limit="6" :host-url="host_url" :upload-url="host_url+'/admin/common/uploadFile?name=card_style'" />-->
          <UploadImage v-model="themeForm.value" />
        </template>
        <template v-if="themeForm.type==='article_list'">
          <ArticleSysc :limit="10" v-model="themeForm.value" />
        </template>
        <template v-if="themeForm.type==='article'">
          <ArticleSysc :limit="1" v-model="themeForm.value"/>
        </template>
        <template v-if="themeForm.type==='nav_bar'">
          <el-color-picker v-model="themeForm.value"></el-color-picker>
        </template>
        <template v-if="themeForm.type==='bottom_bar'">
          <el-color-picker v-model="themeForm.value"></el-color-picker>
        </template>
      </el-form-item>
      <el-form-item label="跳转页面" v-if="themeForm.type==='image'" prop="name">
        <el-input v-model="themeForm.page" autocomplete="off"></el-input>
      </el-form-item>


    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="themeDialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="themeSubmitForm()">确 定</el-button>
    </div>
  </el-dialog>

</div>
</template>

<script>

  import { Loading } from 'element-ui';
  import { User, UserGroup } from './common.js'
  import xhHelp from "./xhHelp";
  import UploadFile from "./components/UploadFile";
  import draggable from 'vuedraggable'
  import UploadFileSysc from "./components/UploadFileSysc";
  import ArticleSysc from "./components/ArticleSysc";
  import UploadFilesSysc from "./components/UploadFilesSysc";
  import UploadImage from "./components/UploadImage";

export default {
  name: "CardStyle",
  components: {UploadImage, UploadFilesSysc, ArticleSysc, UploadFileSysc, UploadFile,draggable},
  data () {
    return {
      is_internal: '',
      group_id: '',
      keyword: '',
      loading: false,
      tableData: [],
      groupList: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      formLoading: false,
      form: {
        id:'',
        name:'',
        images:'',
        nav_bar_color:'',
        bottom_bar_color:'',
        theme_color:'',
        content:'',
        status:true,
        create_time:'',
        update_time:'',
      },
      form_imgs:null,
      rules: {
        // name: [
        //   { required: true, message: '请填写姓名', trigger: 'blur' },
        // ],
        // phone: [
        //   { required: true, message: '请填写手机号码', trigger: 'blur' },
        // ],
        // is_internal: [
        //   { required: true, message: '请选择是否内部成员', trigger: 'change' },
        // ],
        // group_id: [
        //   { required: true, message: '请选择分组', trigger: 'change' },
        // ],
      },
      articleTableData:[],
      articleKeyword:"",
      hostUrl:xhHelp.hostUrl,
      host_url:xhHelp.host_url,
      theme_list:[
        {id:1,name:'名片卡',type:'card',value:''},
        // {id:2,name:'导航栏背景色',type:'nav_bar',value:''},
        // {id:3,name:'底部背景色',type:'bottom_bar',value:''},
      ],
      drag:true,
      type_list:[
        {name:'图片',value:'image'},
        {name:'文章列表',value:'article_list'},
        {name:'文章',value:'article'},
        {name:'名片',value:'card'},
        {name:'视频',value:'video'},
        {name:'多图水平',value:'images_row'},
        {name:'多图纵向',value:'images_col'},
        {name:'自定义公司信息',value:'orginfo'},
        // {name:'导航栏背景色',value:'nav_bar'},
        // {name:'底部背景色',value:'bottom_bar'}
      ],
      themeDialogVisible:false,
      themeForm:{
        id:"",
        name:"",
        type:"",
        value: "",
        page:""
      },
      is_del_type:['image','article_list','article','video','images_row','images_col','orginfo'],
      is_editor_type:['card','image','article_list','article','nav_bar','bottom_bar','video','images_row','images_col','orginfo'],
    }
  },
  created() {

    UserGroup.getList(res => {
      if(res.code == 0) {
        this.groupList = res.data.data
      }
    })

    this.getList()

  },
  methods: {
    getFormData(data) {
      return Object.assign({
        id:'',
        name:'',
        images:'',
        nav_bar_color:'',
        bottom_bar_color:'',
        theme_color:'',
        content:'',
        status:true,
        create_time:'',
        update_time:'',
      }, data)
    },
    search() {
      this.page = 1
      this.getList()
    },
    getList() {
      // User.getList({keyword: this.keyword, page: this.page, page_size: this.pageSize}, res => {
      //   if(res.code == 0) {
      //     this.total = res.data.total
      //     this.tableData = res.data.data
      //   }
      // })
      xhHelp.get("CardStyle/getList",{keyword: this.keyword, page: this.page, page_size: this.pageSize},res => {
        if(res.code == 0) {
          if(res.code == 0) {
            this.total = res.data.total
            this.tableData = res.data.data
          }
        }
      })

    },
    pageChange(i) {
      this.page = i
      this.getList()
    },
    editUser(item=null) {
      if(item){
        let data = {}
        for(let k in this.form) {
          data[k] = item[k]
        }
        // this.form_imgs=[{url:this.hostUrl(data.path)}]
        this.form = data
      }else {
        this.form=this.getFormData({})
      }
      if(this.form.content&&this.form.content.length){
        this.theme_list=this.form.content;
      }else {
        this.theme_list=[
          {id:1,name:'名片卡',type:'card',value:''},
          // {id:2,name:'导航栏背景色',type:'nav_bar',value:''},
          // {id:3,name:'底部背景色',type:'bottom_bar',value:''},
        ];
      }


      //console.log(this.form)

      this.dialogVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formLoading = true
          this.form.content=this.theme_list;
          let data = Object.assign({}, this.form)
          data.content=JSON.stringify(data.content)
          xhHelp.post("CardStyle/update",data,res => {
            this.$message({type: res.code == 0 ? 'success': 'error', message: res.msg})
            if(res.code == 0) {
              this.dialogVisible = false
              this.getList()
            }
            this.formLoading = false
          })

        } else {
          return false;
        }
      });
    },
    setFormItem(item){
      let data = Object.assign({}, item)
      data.content=JSON.stringify(data.content)
      xhHelp.post("CardStyle/update",data,res => {
        this.$message({type: res.code == 0 ? 'success': 'error', message: res.msg})
        if(res.code == 0) {
          this.getList()
        }
      })
    },
    deleteUser(item) {

      this.$confirm('此操作将删除该会员['+item.phone+'], 是否继续?', '提示', {type: 'warning'}).then(() => {
        User.delete(item.id, res => {
          this.$message({type: res.code == 0 ? 'success': 'error', message: res.msg})
          if(res.code == 0) {
            this.getList()
          }
        })
      })

    },
    UploadFileFJSuccess(file){
      if(file){
        this.form_imgs=[{url:this.hostUrl(file)}]
      }else {
        this.form_imgs=null
      }

      this.form.path=file;
    },
    draggableStart(e){
      // console.log(e)
    },
    draggableEnd(e){
      var that=this;
      // let mdData=that.theme_list[newIndex];
      // that.theme_list[newIndex]=that.theme_list[oldIndex]
      console.log(JSON.parse(JSON.stringify(this.theme_list)))
    },
    isDelType(type){
      return this.is_del_type.includes(type)
    },
    isEditorType(type){
      return this.is_editor_type.includes(type)
    },
    getTypeName(type){
      let type_item=this.type_list.find(ret=>{ return ret.value==type })
      return (type_item||{}).name||'--'
    },
    editorTheme(item=null){
      if(item){
        let list=JSON.parse(JSON.stringify(this.theme_list))
        let index=list.findIndex(ret=>{ return ret.id==item.id })
        this.themeForm=list[index]
        console.log(list[index])
      }else {
        this.themeForm={
          id:(new Date()).getTime().toString(),
          name:"",
          type:"",
          value: ""
        }
        this.theme_list.push(JSON.parse(JSON.stringify(this.themeForm)))
      }
      this.themeDialogVisible=true;
    },
    delTheme(item){
      let list=JSON.parse(JSON.stringify(this.theme_list))
      let index=list.findIndex(ret=>{ return ret.id==item.id })
      list.splice(index,1)
      this.theme_list=list;
    },
    themeSubmitForm(){
      var that=this;
      let list=JSON.parse(JSON.stringify(this.theme_list))
      let index=list.findIndex(ret=>{ return ret.id==that.themeForm.id })
      list[index]=JSON.parse(JSON.stringify(that.themeForm))
      this.theme_list=JSON.parse(JSON.stringify(list))
      this.themeDialogVisible=false;
    }
  }
}
</script>
<style lang="scss" scoped>

  @import './common.scss';
  .theme-content{
    width: 600px;
    height: 300px;
    overflow-y: scroll;
    .theme-content-item{
      cursor: move;
      margin: 5px;
      //height: 40px;
      //line-height: 40px;
      padding: 5px;

      background-color: #7ecbff;
      box-shadow: 0 0 4px -2px #999;
      border-radius: 5px;
      color: white;
    }
    .theme-content-footer{
      text-align: center;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Card/CardStyle.vue